import { useNavigate } from "react-router-dom";
import { CheckedCircle } from "../../components/svg/GeneralIcons";
import { AppLayout } from "../../layout/AppLayout";
import { motion } from "framer-motion";
import Button from "../../components/button/Button";
import { Arrow } from "../../components/svg/Wallet/Wallet";

export const RedeemSuccess = () => {
  const navigate = useNavigate();
  return (
    <AppLayout noNav bg={"!bg-[#F8F8F8]"}>
      <div className="pt-16 pb-7 px-5 min-h-screen flex flex-col">
        <motion.div
          initial={{ opacity: 0, scale: 0.2 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="w-full relative flex flex-col flex-grow"
        >
          <div className="relative flex items-center justify-center mb-10">
            <Arrow
              onClick={() => navigate(-1)}
              stroke="#fff"
              className="text-lg absolute left-0 cursor-pointer"
            />
            <p className="font-bold text-xl text-black">Redeem</p>
          </div>

          <div className=" flex-grow flex justify-between items-center flex-col h-full gap-5">
            <div className="flex-grow flex items-center flex-col w-full ">
              <CheckedCircle />
              <div className="my-12 mb-7 text-center">
                <p className="text-black text-3xl font-semibold">Success!</p>
                <p className="text-lg text-black font-medium">
                  Points redeemed successfully
                </p>
              </div>

              <div className=" w-full  border border-[#0000004D] bg-white rounded-md px-3.5 pb-4 pt-3.5 font-semibold text-4xl text-center">
                ₦30,000
              </div>
            </div>
            <div className="mt-4 w-full">
              <Button
                onClick={() => navigate("/settings/wallet")}
                text="View Wallet"
              />
            </div>
          </div>
        </motion.div>
      </div>
    </AppLayout>
  );
};
